const isIntGreaterThan = compareNumber => number => {
  const numValue = Number(number);
  return Number.isInteger(numValue) && numValue > compareNumber;
};

export default isIntGreaterThan;
